import React from 'react';

import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 10px;
  position: relative;

  &::after {
    content: '';
    display: block;
    height: 1px;
    width: 100%;
    background-image: linear-gradient(to right, var(--line-gray) 0%, var(--background-gray-light));
    position: absolute;
    bottom: 0;
  }
`;

const Title = styled.p`
  color: var(--text-primary);
  font-size: 20px;
  font-family: var(--font-bold);
  display: flex;
  gap: 4px;
`;

const Controls = styled.div``;

type Props = {
  title: string;
  addOn?: React.ReactNode;
  controls?: React.ReactNode;
};

const Header = ({ title, addOn, controls }: Props) => {
  return (
    <Container>
      <Title>
        {title}
        {addOn && addOn}
      </Title>
      {controls && <Controls>{controls}</Controls>}
    </Container>
  );
};

export default Header;
